import React from "react";
import { Info } from "react-feather";

export function Label({ className, children }) {
  return <label className={["label", className ? className : ""].join(" ")}>{children}</label>;
}

export default function Input({ icon, label, type, value, onChange, id, size = "lg", error, name, info, placeholder, maxlength, autoComplete = "on" }) {
  let hasError = error && ((value && value === error.val) || !value);

  return (
    <div className="input-wrap">
      <input
        id={id}
        name={name}
        type={type}
        className={["input", "input-" + size, hasError ? "input-error" : ""].join(" ")}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxlength}
        autoComplete={autoComplete}
      />
      <Label>{label}</Label>

      {info ? <small className="input-info">{info}</small> : null}
      {hasError ? (
        <div className="error">
          <Info size={16} />
          {error.msg}
        </div>
      ) : null}
    </div>
  );
}
